export const AUTHENTICATOR_SIGNUP = "SIGNUP"
export const AUTHENTICATOR_VERIFY = "VERIFY"
export const AUTHENTICATOR_SIGNIN = "SIGNIN"
export const AUTHENTICATOR_FORGOT = "FORGOT"
export const AUTHENTICATOR_RESET = "RESET"
export const AUTHENTICATOR_RESETNEW = "RESETNEW"
export const AUTHENTICATOR_WELCOME = "WELCOME"